"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.heatValue = exports.heatLevel = exports.exclamationsFor = void 0;
// @wasp/heat — the heat scale shared by the boards: how close a task is to
// holding the kitchen back, by its slack in minutes. Pure.
var heat_1 = require("./heat");
Object.defineProperty(exports, "exclamationsFor", { enumerable: true, get: function () { return heat_1.exclamationsFor; } });
Object.defineProperty(exports, "heatLevel", { enumerable: true, get: function () { return heat_1.heatLevel; } });
Object.defineProperty(exports, "heatValue", { enumerable: true, get: function () { return heat_1.heatValue; } });
//# sourceMappingURL=index.js.map